import React from "react";
import col from "../../images/collecteur.png";
import colldetails from "../../images/coll-details.png";
import "./carouselAnimation.css";

const MarivelCollecteur = () => {
  return (
    <div>
      <section
        className="p-4 text-center sm:p-6 md:p-10 lg:p-20 bg-black/70 bg-blend-overlay"
        style={{
          backgroundImage: `url(${col})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <h1 className="text-xl font-bold text-center text-white sm:text-2xl md:text-3xl">
          Les Collecteurs du Ru de Marivel
        </h1>
        <p className="max-w-3xl mx-auto mt-4 text-base text-white">
          Une mission pour nos rivières et nos territoires
        </p>
      </section>

      <div className="container px-4 mx-auto mt-8 mb-10 sm:mt-20 sm:px-6 lg:px-8">
        <div className="space-y-4">
          <div>
            <h2 className="text-xl font-bold text-black">Collecteur A</h2>
            <p className="text-base text-black">
              Il faut attendre la décision ministérielle du 31 mars 1894 pour
              voir la création de l’égout dit collecteur A, en 1896 et 1897. Six
              communications sont créées entre cet égout et le Ru de Marivel,
              afin de soulager celui-ci lors de fortes pluies. De plus, l’égout
              recevra le Ru de Montreuil et le Ru de la Voirie (eaux du Versant
              Nord), tandis que le Ru de Marivel continuera à recevoir les Rus
              de la Patte d’Oie, de la Ferme de Chaville, de Meudon (eaux du
              Versant Sud). Enfin, l’exutoire de l’égout sera localisé sur le Ru
              de Marivel, environ 80 m avant le rejet de celui-ci en Seine.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-black">12 avril 1923</h2>
            <p className="text-base text-black">
              Avant-projet concernant la construction d’un nouvel égout,
              parallèle au premier égout et au Ru de Marivel, afin de pallier
              aux insuffisances de ces deux ouvrages.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-black">Collecteur B</h2>
            <p className="text-base text-black">
              <span className="font-bold">29 mars 1928 :</span> Syndicat
              Intercommunal du Ru de Marivel reprend cette idée, ce nouvel égout
              serait « régional », profond, au contraire du premier égout, plus
              « local », et peu profond, des communications seront créées entre
              ces deux égouts. La réalisation du collecteur B démarre en 1929.{" "}
              <br />
              Le Ru de Marivel pourrait se déverser dans ce nouvel égout, et les
              collecteurs qui canalisaient le Ru de Marivel disparaîtraient
              progressivement, au fur et à mesure des nouvelles constructions
              situées sur le tracé, et, ainsi de la constitution de tronçon aux
              linéaires de plus en plus faibles. <br />
              L’objectif dès 1928, était donc la disparition progressive des
              collecteurs qui canalisaient alors le Ru de Marivel, c’est-à-dire
              la disparition progressive de ce qui est aujourd’hui appelé «
              Ancien Ru de Marivel ».
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-black">1937 et plus</h2>
            <p className="text-base text-black">
              Le Syndicat du Ru de Marivel entreprend des travaux de réfection
              et d’aménagement sur les collecteurs créés, parallèlement, des
              effondrements de la voûte du Ru de Marivel sont signalés par des
              riverains.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-black">1865</h2>
            <p className="text-base text-black">
              Menace d’une épidémie de choléra : Le Ministre prescrit la
              production immédiate de projets afin d’améliorer l’état du Ru,
              insalubre.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-black">Collecteur D</h2>
            <p className="text-base text-black">
              <span className="font-bold">1959 à 1964 :</span> Le Syndicat
              Intercommunal du Ru de Marivel entreprend la construction d’un
              troisième collecteur, parallèle aux deux premiers et au Ru de
              Marivel dénommé collecteur D a été réalisé.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-bold text-black">Collecteur J</h2>
            <p className="text-base text-black">
              <span className="font-bold">1955 à 1957 :</span> Le Syndicat
              Intercommunal du Ru de Marivel entreprend la construction d’un
              collecteur sous la RN307 entre Sèvres et Ville d’Avray (partie
              basse du collecteur J). <br />
              <span className="font-bold">1963 à 1964 :</span> Le Syndicat
              Intercommunal du Ru de Marivel entreprend la construction d’un
              collecteur sous the RN307 entre Ville d’Avray et Marnes la
              Coquette (partie haute du collecteur J).
            </p>
          </div>
        </div>

        <div className="flex justify-center mt-8 sm:mt-10">
          <img
            src={colldetails}
            alt="Details of Ru de Marivel collecteurs"
            className="w-full h-auto max-w-xs rounded-lg sm:max-w-sm md:max-w-md"
          />
        </div>
      </div>
    </div>
  );
};

export default MarivelCollecteur;
